import { semanticColors } from '@moderneinc/design-system-tokens';
import { Box } from '@mui/material';
import type { FunctionComponent } from 'react';

/**
 * The Moderne monogram rendered in the current theme's text colour.
 *
 * Uses a CSS mask rather than `<img src>` so the mark flips in dark mode:
 * `moderne-icon.svg` is a `currentColor` SVG, but an SVG loaded through `<img>`
 * resolves `currentColor` against its own document root (always black), not the
 * page. Masking paints a Box in `color.text.primary` (which flips light/dark) and
 * punches it through the SVG's shape.
 */
export const ModerneMonogram: FunctionComponent<{ size?: number }> = ({
  size = 30
}) => (
  <Box
    role="img"
    aria-label="Moderne"
    sx={{
      height: size,
      width: size,
      flexShrink: 0,
      backgroundColor: semanticColors.color.text.primary,
      maskImage: 'url(/moderne-icon.svg)',
      maskSize: 'contain',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      WebkitMaskImage: 'url(/moderne-icon.svg)',
      WebkitMaskSize: 'contain',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center'
    }}
  />
);
